export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAIUlEQVR4AWMY6eA/DGKKUFEDFkAnDcMRDHyw0iEtjWwAAFpGP8HlyvTiAAAAAElFTkSuQmCC"